import React from 'react';
import StartState from '@/features/generation/StartState';
import ProcessingState from '@/features/generation/ProcessingState';
import GeneratedState from '@/features/generation/GeneratedState';
import FormState from '@/features/generation/FormState';
import Recorder from '@/features/recording/Recorder';
import { CardWrapper } from '@/shared/components/CardWrapper'

export function MediaInputView({
  mode,
  inputStatus,
  generateReport,
  disabled,
  isDisabled,
  nonAudioTool,
  handleStart,
  handleBrowseClick,
  handleDrop,
  handleDragOver,
  handleFileChange,
  fileInputRef,
  acceptedTypes,
  uploadModelOpen,
  handleAudio,
  setRecordingTime,
  finalising,
  setFinalising,
  abandonRecordingRef,
  recordingTime,
  audioDuration,
  selectedFile,
  recordedBlob,
  formatTime,
  onGenerateReport,
  setGenerateReport,
  activeDraft,
  uploading,
  generating,
  handleResetState,
  handleGoToReport,
  confirmIfSilent,
}) {
  if (inputStatus === 'start' && generateReport === '') {
    const content = (
      <StartState
        mode={mode}
        disabled={disabled}
        isDisabled={isDisabled}
        onStart={handleStart}
        onBrowseClick={mode === 'upload' ? handleBrowseClick : undefined}
        uploadModelOpen={uploadModelOpen}
        nonAudioTool={nonAudioTool}
      />
    );

    return (
      <CardWrapper className='border-none'>
        <div
          className={`flex flex-col items-center justify-center w-full border border-[#E4E4E7] p-5 rounded-xl ${disabled && 'cursor-not-allowed'}`}
          onDrop={handleDrop}
          onDragOver={handleDragOver}
          data-tooltip-id='no-words' 
          data-tooltip-content='No more words left. Please contact MPAssist.'
        >
          {content}
          <input
            type="file"
            onChange={handleFileChange}
            className="hidden"
            ref={fileInputRef}
            id="fileInput"
            accept={acceptedTypes}
            multiple={nonAudioTool}
          />
        </div>
      </CardWrapper>
    );
  }

  if (inputStatus === 'recording') {
    return (
      <div className='flex w-full flex-col justify-center items-center'>
        <div className='flex w-full flex-col justify-center items-center p-5 rounded-xl border border-[#E4E4E7]'>
          <Recorder 
            handleAudio={handleAudio} 
            autoStart={true} 
            setRecordingTime={setRecordingTime}
            finalising={finalising}
            setFinalising={setFinalising}
            onAbandonReady={(abandon) => { abandonRecordingRef.current = abandon; }}
            confirmIfSilent={confirmIfSilent}
          />
        </div>
      </div>
    );
  }

  if (inputStatus === 'stopped' && generateReport === '' && (recordedBlob || selectedFile)) {
    const content = (
      <FormState
        mode={mode}
        recordingTime={recordingTime}
        audioDuration={audioDuration}
        selectedFile={selectedFile}
        recordedBlob={recordedBlob}
        formatTime={formatTime}
        onGenerateReport={onGenerateReport}
        setGenerateReport={setGenerateReport}
        nonAudioTool={nonAudioTool}
        draftFormData={activeDraft?.formData}
      />
    );

    return mode === 'upload' ? (
      <CardWrapper className='border-none'>{content}</CardWrapper>
    ) : content;
  }

  if (generateReport === 'generating') {
    const content = (
      <ProcessingState
        uploading={uploading}
        generating={generating}
        onReset={handleResetState}
      />
    );

    return mode === 'upload' ? (
      <CardWrapper className='border-none'>{content}</CardWrapper>
    ) : content;
  }

  if (generateReport === 'completed') {
    return (
      <GeneratedState onGoToReport={handleGoToReport} />
    );
  }

  return null;
}
